// extracted by mini-css-extract-plugin
module.exports = {"container":"thankyou_container__3YGkp","form":"thankyou_form__3fqpN"};